import Vue from 'vue'
import AuthModule from '@/auth'

export const registerAuth = () => {
  Vue.prototype.$auth = new AuthModule()
}